module.exports = __webpack_public_path__ + "img/345.5de0445f.jpg";